import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import OrderForm from "./components/OrderForm";
import AdminDashboard from "./components/AdminDashboard";
import HomePage from "./components/HomePage";
import FranchiseLogin from "./components/FranchiseLogin";
import PaymentConfirmation from "./components/PaymentConfirmation";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/franchise-login" element={<FranchiseLogin />} />
          <Route path="/order" element={<OrderForm />} />
          <Route path="/payment-confirmation" element={<PaymentConfirmation />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;